/**
 * Removed the component entirely so it renders null
 */
const MarkdownIntroduction = (props) => {
  return null;
};

export default MarkdownIntroduction;
